import { PURCHASING_FLAGS } from '@notifi/shared-types/feature-flags';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { RequireFeatureFlag } from '@/features/feature-flags/RequireFeatureFlag';

/** Every inventory page sits behind the inventory flag (PLAT-FF-1). */
function InventoryArea() {
  return (
    <RequireFeatureFlag flag={PURCHASING_FLAGS.inventory} title="Inventory">
      <Outlet />
    </RequireFeatureFlag>
  );
}

export const Route = createFileRoute('/_dashboard/dashboard/inventory')({
  component: InventoryArea,
});
